import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/insurance/add-white.png'
import _imports_1 from '@/assets/img/insurance/reduce-white.png'


const _withScopeId = n => (_pushScopeId("data-v-80161418"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "date" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "btn-icon",
  src: _imports_0
}, null, -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  class: "btn-icon",
  src: _imports_1
}, null, -1))
const _hoisted_4 = /*#__PURE__*/_createTextVNode(" 减保 ")
const _hoisted_5 = [
  _hoisted_3,
  _hoisted_4
]
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("button", { class: "mini-btn white" }, "导出", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("在保人员")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("月度账单")
const _hoisted_9 = { class: "container" }
const _hoisted_10 = { class: "row" }
const _hoisted_11 = { class: "form" }
const _hoisted_12 = { class: "form-row" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "key" }, "选择月份：", -1))
const _hoisted_14 = { class: "form-row" }
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "key" }, "格式：", -1))
const _hoisted_16 = /*#__PURE__*/_createTextVNode("按天")
const _hoisted_17 = /*#__PURE__*/_createTextVNode("按人员")
const _hoisted_18 = { class: "foot" }
const _hoisted_19 = { class: "form" }
const _hoisted_20 = { class: "form-row" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "保险：", -1))
const _hoisted_22 = { class: "form-value" }
const _hoisted_23 = { class: "form-row" }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "人数：", -1))
const _hoisted_25 = { class: "form-value" }
const _hoisted_26 = { style: {"font-size":"18px","font-weight":"bold"} }
const _hoisted_27 = /*#__PURE__*/_createTextVNode("人 ")
const _hoisted_28 = { class: "form-row" }
const _hoisted_29 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "续保周期：", -1))
const _hoisted_30 = { class: "form-value" }
const _hoisted_31 = { class: "form-row" }
const _hoisted_32 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "form-key" }, "费用：", -1))
const _hoisted_33 = { class: "form-value" }
const _hoisted_34 = { style: {"font-size":"18px","font-weight":"bold"} }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("元 ")
const _hoisted_36 = { class: "alert-bottom" }
const _hoisted_37 = { class: "block" }
const _hoisted_38 = { class: "table" }
const _hoisted_39 = { class: "row" }
const _hoisted_40 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "" }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_dropdown_item = _resolveComponent("el-dropdown-item")!
  const _component_el_dropdown_menu = _resolveComponent("el-dropdown-menu")!
  const _component_el_dropdown = _resolveComponent("el-dropdown")!
  const _component_page_head = _resolveComponent("page-head")!
  const _component_plan_rule = _resolveComponent("plan-rule")!
  const _component_alert_box = _resolveComponent("alert-box")!
  const _component_component_detail = _resolveComponent("component-detail")!
  const _component_component_record = _resolveComponent("component-record")!
  const _component_component_statistics = _resolveComponent("component-statistics")!
  const _component_component_people = _resolveComponent("component-people")!
  const _component_el_date_picker = _resolveComponent("el-date-picker")!
  const _component_el_radio = _resolveComponent("el-radio")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_page_head, {
      title: _ctx.detail?.plan?.name
    }, {
      left: _withCtx(() => [
        _createElementVNode("div", _hoisted_1, _toDisplayString(_ctx.detail.start_date) + " 至 " + _toDisplayString(_ctx.detail.end_date || '长期有效'), 1),
        (_ctx.detail?.plan?.tips !== '')
          ? (_openBlock(), _createElementBlock("span", {
              key: 0,
              style: {"margin-left":"15px","font-size":"12px","color":"#1A90F5","cursor":"pointer"},
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.showPlanRule = true))
            }, "《方案条款》"))
          : _createCommentVNode("", true)
      ]),
      right: _withCtx(() => [
        (_ctx.detail.can_renew)
          ? (_openBlock(), _createElementBlock("button", {
              key: 0,
              class: "mini-btn blue",
              onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onRenew && _ctx.onRenew(...args)))
            }, "一键续保"))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "mini-btn green",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goAddSubtract('add')))
        }, [
          _hoisted_2,
          _createTextVNode(" " + _toDisplayString(_ctx.detail?.plan?.type === '日日保' ? '加保24小时' : '加保'), 1)
        ]),
        (_ctx.detail?.plan?.type != '日日保')
          ? (_openBlock(), _createElementBlock("button", {
              key: 1,
              class: "mini-btn red",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.goAddSubtract('subtract')))
            }, _hoisted_5))
          : _createCommentVNode("", true),
        _createVNode(_component_el_dropdown, {
          placement: "bottom-start",
          trigger: "hover"
        }, {
          dropdown: _withCtx(() => [
            _createVNode(_component_el_dropdown_menu, null, {
              default: _withCtx(() => [
                _createVNode(_component_el_dropdown_item, { onClick: _ctx.onExportActive }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["onClick"]),
                _createVNode(_component_el_dropdown_item, {
                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.isExport = true))
                }, {
                  default: _withCtx(() => [
                    _hoisted_8
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          default: _withCtx(() => [
            _hoisted_6
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["title"]),
    (_ctx.showPlanRule)
      ? (_openBlock(), _createBlock(_component_alert_box, {
          key: 0,
          dataTitle: "方案条款",
          width: "600px",
          onClose: _cache[6] || (_cache[6] = ($event: any) => (_ctx.showPlanRule= false))
        }, {
          default: _withCtx(() => [
            _createVNode(_component_plan_rule, {
              rule: _ctx.detail.plan.tips,
              onClose: _cache[5] || (_cache[5] = ($event: any) => (_ctx.showPlanRule= false))
            }, null, 8, ["rule"])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_9, [
      _createVNode(_component_component_detail, { data: _ctx.detail }, null, 8, ["data"]),
      _createElementVNode("div", _hoisted_10, [
        _createVNode(_component_component_record, {
          id: _ctx.id,
          style: {"width":"66%","min-height":"544px","margin-right":"20px"}
        }, null, 8, ["id"]),
        _createVNode(_component_component_statistics, {
          id: _ctx.id,
          style: {"width":"32%","min-height":"544px"}
        }, null, 8, ["id"])
      ]),
      _createVNode(_component_component_people, { id: _ctx.id }, null, 8, ["id"])
    ]),
    (_ctx.isExport)
      ? (_openBlock(), _createBlock(_component_alert_box, {
          key: 1,
          dataTitle: "导出账单",
          width: "480px",
          onClose: _ctx.close
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_11, [
              _createElementVNode("div", _hoisted_12, [
                _hoisted_13,
                _createVNode(_component_el_date_picker, {
                  modelValue: _ctx.timeMonth,
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.timeMonth) = $event)),
                  class: "value",
                  type: "month",
                  placeholder: "选择月份",
                  "value-format": "YYYY-MM",
                  format: "YYYY-MM"
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_14, [
                _hoisted_15,
                _createVNode(_component_el_radio_group, {
                  modelValue: _ctx.exportType,
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.exportType) = $event)),
                  class: "value"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio, { label: "date" }, {
                      default: _withCtx(() => [
                        _hoisted_16
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_radio, { label: "person" }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("button", {
                class: "btn-white",
                onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.isExport = false))
              }, "取消"),
              _createElementVNode("button", {
                class: "btn btn-alone",
                onClick: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.onExport && _ctx.onExport(...args)))
              }, "确定导出")
            ])
          ]),
          _: 1
        }, 8, ["onClose"]))
      : _createCommentVNode("", true),
    (_ctx.isRenew)
      ? (_openBlock(), _createBlock(_component_alert_box, {
          key: 2,
          class: "alert-form",
          width: "500px",
          dataTitle: "一键续保",
          onClose: _cache[14] || (_cache[14] = ($event: any) => (_ctx.isRenew = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_19, [
              _createElementVNode("div", _hoisted_20, [
                _hoisted_21,
                _createElementVNode("div", _hoisted_22, _toDisplayString(_ctx.detail.plan.name), 1)
              ]),
              _createElementVNode("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.renewData.payCount), 1),
                  _hoisted_27,
                  _createElementVNode("span", {
                    class: "link",
                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.isRenewPeople = true)),
                    style: {"margin-left":"6px"}
                  }, "查看详情")
                ])
              ]),
              _createElementVNode("div", _hoisted_28, [
                _hoisted_29,
                _createElementVNode("div", _hoisted_30, _toDisplayString(_ctx.renewData.startDate) + " 至 " + _toDisplayString(_ctx.renewData.endDate), 1)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _hoisted_32,
                _createElementVNode("div", _hoisted_33, [
                  _createElementVNode("span", _hoisted_34, _toDisplayString(_ctx.renewData.payMoney), 1),
                  _hoisted_35
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_36, [
              _createElementVNode("button", {
                class: "mini-btn white",
                onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.isRenew = false))
              }, "取消"),
              _createElementVNode("button", {
                class: "mini-btn blue",
                onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => (_ctx.onSubmitRenew && _ctx.onSubmitRenew(...args)))
              }, "确定")
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (_ctx.isRenew && _ctx.isRenewPeople)
      ? (_openBlock(), _createBlock(_component_alert_box, {
          key: 3,
          onClose: _cache[18] || (_cache[18] = ($event: any) => (_ctx.isRenewPeople = false)),
          dataTitle: "续保员工"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("div", _hoisted_38, [
                _createVNode(_component_el_table, {
                  data: _ctx.renewData.personList.slice(_ctx.renewPageSize * (_ctx.renewPage - 1), _ctx.renewPageSize * _ctx.renewPage),
                  style: {"width":"100%"},
                  "header-cell-class-name": "table-head",
                  "row-style": { color: '#5E617D' }
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_table_column, {
                      type: "index",
                      fixed: "",
                      label: "序号"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "employee.name",
                      label: "姓名"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "employee.idcard",
                      label: "身份证号"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "company_name",
                      label: "被派遣单位"
                    }),
                    _createVNode(_component_el_table_column, {
                      prop: "occupation_name",
                      formatter: (item) => item.occupation_name + `（${item.occupation_level}类）`,
                      label: "工种"
                    }, null, 8, ["formatter"])
                  ]),
                  _: 1
                }, 8, ["data"])
              ]),
              _createElementVNode("div", _hoisted_39, [
                _hoisted_40,
                _createVNode(_component_el_pagination, {
                  currentPage: _ctx.renewPage,
                  "onUpdate:currentPage": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.renewPage) = $event)),
                  small: "",
                  layout: "total, sizes, prev, pager, next",
                  total: _ctx.renewData.personList.length,
                  "page-size": _ctx.renewPageSize,
                  "onUpdate:page-size": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.renewPageSize) = $event)),
                  "page-sizes": [5, 30, 50, 100],
                  class: "pagination",
                  onSizeChange: _cache[17] || (_cache[17] = ($event: any) => (_ctx.renewPage = 1))
                }, null, 8, ["currentPage", "total", "page-size"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}